// allow customize 404 via theme slots
export { default } from 'dumi/theme/slots/NotFound';